import FocusTrap from "focus-trap-react";

export default FocusTrap;
